import axios from "axios";
import { Apis } from "constants/apis";
import { getToken } from "utils/token";


const createCoupon = async (payload: any) => {
    const { data } = await axios.post(Apis.CREATE_COUPON, payload, { headers: { Authorization: getToken() } })
    return data
}

export default createCoupon